export class ExplodedView {
	constructor($element) {
		this.$element = $element;
		if (!this.$element) return;

		this.init();
	}

	init() {
		this.$markers = this.$element.querySelector('[data-wnfgr="markers"]');

		if (this.isReady()) {
			this.bindPoints();
			return;
		}

		this.observeReady();
	}

	isReady() {
		if (!this.$markers) return false;
		if (this.$markers.classList.contains('imarker-load')) return false;

		return this.$element.querySelectorAll('.point').length > 0;
	}

	observeReady() {
		const target = this.$markers || this.$element;

		this.observer = new MutationObserver(() => {
			if (!this.isReady()) return;

			this.observer.disconnect();
			this.observer = null;
			this.bindPoints();
		});

		this.observer.observe(target, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class'],
		});
	}

	bindPoints() {
		if (this.isBound) return;
		this.isBound = true;

		const points = this.$element.querySelectorAll('.point');

		points.forEach((point) => {
			const link = point.querySelector('.tooltipe-link a.button[href]');
			const icon = point.querySelector('.point-icon');

			if (!link || !icon) return;

			const href = link.getAttribute('href');
			if (!href) return;

			icon.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				window.location.href = href;
			});
		});
	}

	destroy() {
		this.observer?.disconnect();
		this.observer = null;
	}
}

export const initExplodedViews = () => {
	const items = document.querySelectorAll('.exploded-view');

	items.forEach(($element) => new ExplodedView($element));
};
